module.exports = __webpack_public_path__ + "static/media/lso.021d44f4.svg";